import styled from 'styled-components/macro';

export const FloatButton = styled.div`
  pointer-events: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  width: 100%;

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  @media screen and (max-device-width: 767px) {
    @media screen and (max-width: 767px) {
      padding: 0 10px;

      ${({ isHalf }) =>
        isHalf == 'left' &&
        `
    padding: 0 0 0 10px;
    `}

      ${({ isHalf }) =>
        isHalf == 'right' &&
        `
    padding: 0 10px 0 0;
    `}
    }
  }
  & > div {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;

    ${({ isHalf }) =>
      isHalf == 'left' &&
      `
    padding: 10px 5px 10px 10px;
    `}

    ${({ isHalf }) =>
      isHalf == 'right' &&
      `
    padding: 10px 10px 10px 5px;
    `}


    & > div {
      transition: all 0.25s ease-in-out;
      background: ${({ color, colorD2 }) =>
        `linear-gradient(180deg, ${color} 32.22%, ${colorD2} 120%);`};
      cursor: pointer;

      ${({ hasScroll }) =>
        hasScroll ? `width: calc(100% - 10px);` : `width: 100%;`}

      ${({ disabled }) =>
        disabled &&
        `
          opacity: 0.5;
          pointer-events: none;
        `}

box-sizing: border-box;
      border: 3px solid rgba(255, 255, 255, 0.45);

      height: 46px;
      border-radius: 24px;

      @media screen and (max-width: 767px) {
        height: 50px;
        border-radius: 15px;
      }
      box-shadow: 0 0 6px 1px rgb(0 0 0 / 28%),
        inset 0px 2px 8px rgba(255, 255, 255, 0.15);

      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        filter: brightness(1.1);
        opacity: 0.95;
      }
      &:active {
        transform: scale(0.99);
      }

      & > div {
        & .button-icon {
          color: white;
        }
        & .button-label {
          font-weight: bold;
          color: white;
          text-shadow: 0px 3px 4px rgb(0 0 0 / 20%);
        }
      }
    }
  }
`;

export const Card = styled.div`
  position: absolute;

  ${({ type }) =>
    type != 'Task' &&
    `
    padding-right: 40px;
    `}

  ${({ type }) =>
    type == 'Task' &&
    `
      left: 50%;
    transform: translateX(-50%);
   
  `}

  width: ${({ type }) => (type == 'Task' ? '40vw' : '100%')};

  ${({ type }) =>
    type == 'Task' &&
    `

@media screen and (max-width: 1212px) {
    width: 50vw;
  }

    `};

  height: 100%;
  bottom: 0;

  padding-bottom: 10px;

  @media screen and (max-width: 767px) {
    width: 80vw;
    left: 50%;
    transform: translateX(-50%);
    padding: 10px 20px;
  }

  @media screen and (max-width: 549px) {
    width: 100%;
    padding: 10px;
  }

  z-index: 199;
  box-sizing: border-box;
  pointer-events: none;

  & > div:first-child {
    pointer-events: auto;
    width: 100%;
    height: 100%;

    & > div:first-child {
      width: 100%;
      height: 100%;
      justify-content: space-between;
      display: flex;
      flex-direction: column;
      padding: 10px;
      box-sizing: border-box;

      & > div {
        display: flex;
        flex-direction: column;
        box-shadow: 0px 0px 10px 2px rgb(0 0 0 / 35%),
          inset 0px 0px 12px rgba(255, 255, 255, 0.32);
      }

      & > div:nth-child(2) {
        margin-top: 10px;
        border-radius: 20px;
        overflow: hidden;

        & > div:first-child {
          font-weight: bold;
          ${({ disabled }) =>
            disabled &&
            `
          opacity: 0.5;
          pointer-events: none;

        `}

          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        }

        & > div:nth-child(2) {
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
        }

        & > div {
          transition: all 0.25s ease-in-out;
          cursor: pointer;
          border: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px;
          color: ${({ color }) => color};

          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;

          @media screen and (max-width: 767px) {
            height: 24px;
          }

          background: white;
          align-items: center;
          justify-content: center;
          display: flex;
          text-align: center;

          &:hover {
            background: ${({ color_L2 }) => color_L2}!important;
          }
        }
      }
    }
  }
`;

export const SubCard = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
`;

export const CardOptions = styled.div`
  flex: 1;
  overflow-y: overlay;
  overflow-x: hidden;
  background: #e3e3ec;
  border-radius: 20px;
  padding: 16px;

  background: linear-gradient(
    281.96deg,
    rgba(225, 225, 234, 0.8) 4.21%,
    rgba(225, 225, 234, 0.55) 98.56%
  );
  backdrop-filter: blur(5px);

  ${({ type }) =>
    type == 'Task' &&
    ` 
    overflow: hidden;
  
    & .target-child {
   & > div:first-child {
     display: flex; flex-direction: column;
   }
  `}

  & > div:first-child {
    text-align: center;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 20px;
  }

  & > div:not(:first-child) {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgb(0 0 0 / 12%);

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;
